module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"terrain":"Terrain","swap-sides":"Swap sides"},"ru":{"terrain":"Территория","swap-sides":"Поменять стороны"}}')
  delete Component.options._Ctor
}
